
export default function BenefitsSection() {
  const benefits = [
    {
      icon: "ri-group-line",
      title: "Accès à une clientèle qualifiée",
      description: "Bénéficiez de notre réseau de clients motivés et pré-qualifiés, sans effort de prospection de votre part."
    },
    {
      icon: "ri-calendar-check-line",
      title: "Gestion simplifiée",
      description: "Notre plateforme gère les réservations, paiements et planning pour que vous puissiez vous concentrer sur le coaching."
    },
    {
      icon: "ri-money-euro-circle-line",
      title: "Revenus attractifs",
      description: "Fixez vos tarifs et gardez 80% de vos revenus. Paiements sécurisés et versements réguliers garantis."
    },
    {
      icon: "ri-graduation-cap-line",
      title: "Formation continue",
      description: "Accédez à nos formations exclusives et développez vos compétences avec les dernières méthodes de coaching."
    },
    {
      icon: "ri-shield-check-line",
      title: "Support professionnel",
      description: "Bénéficiez d'un support technique et commercial dédié pour optimiser votre activité de coaching."
    },
    {
      icon: "ri-line-chart-line",
      title: "Croissance assurée",
      description: "Développez votre réputation grâce à notre système d'avis clients et notre marketing digital."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Pourquoi Rejoindre Notre Réseau ?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Découvrez tous les avantages de devenir coach partenaire sur notre plateforme
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${benefit.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
